<template>
    <Multiselect
        :id="id"
        ref="select"
        v-model="selected"
        :tag-placeholder="tagPlaceholder"
        :placeholder="placeholder"
        track-by="id"
        label="name"
        selected-label=""
        :options="options"
        :multiple="false"
        :taggable="taggable"
        :loading="loading"
        :internal-search="false"
        @search-change="search"
        @tag="tag"
    />
</template>

<script>
import Multiselect from 'vue-multiselect';
import debounce from 'debounce';
import api from '@/modules/costable/_api';

export default {

    components: { Multiselect },

    props: {
        id: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: 'Select...',
        },
        taggable: {
            type: Boolean,
            default: true,
        },
        tagPlaceholder: {
            type: String,
            default: 'Add...',
        },
        value: {
            type: Object,
            default: null,
        },
        onlyWithResources: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: false,
            taggedAccountName: '',
            options: [],
        };
    },

    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },

    created() {
        this.$eventBus.$on(this.$events.createAccountModalSuccess, (e) => {
            this.selected = e.newAccount;
        });
    },

    methods: {
        reset() {
            this.selected = null;
            this.options = [];
        },
        search: debounce(function debounceSearch(query) {
            if (!query.trim()) return;
            this.loading = true;
            api.accountSearch(encodeURIComponent(query), this.onlyWithResources)
                .then((response) => {
                    this.options = response;
                    this.loading = false;
                });
        }, 500),
        tag(name) {
            this.$eventBus.$emit(this.$events.openCreateAccountModal, {
                accountName: name,
            });
        },
        focusSelect() {
            this.$refs.select.$el.focus();
        },
    },

};
</script>
